import React from 'react';
import classNames from 'classnames';
import { formatText } from 'core/i18n';

export const PasswordRequirements = ({ hasErrors, passAscDesc, passEquals, passBirthDay, passBirthYear }) => {
    const passwordRequirements = classNames('col-sm-8 md-form-group initial-step-password-requirements', {
        'prospects-animation prospects-animation--shake': hasErrors,
    });

    return (
        <div className={passwordRequirements}>
            <ul>
                <li className={!passAscDesc ? 'requirement-fail' : undefined}>{formatText('field-passAscDesc')}</li>
                <li className={!passEquals ? 'requirement-fail' : undefined}>{formatText('field-passEquals')}</li>
                <li className={!passBirthYear || !passBirthDay ? 'requirement-fail' : undefined}>
                    {formatText('field-passBirthYear')}
                </li>
            </ul>
        </div>
    );
};
